import { Field, FieldProps } from "formik";

import {
  FormControlLabel,
  FormControlLabelProps,
  Switch,
  SwitchProps,
  FormHelperText
} from "@material-ui/core";

export default function FormikSwitchField({
  name,
  label,
  helperText,
  labelProps,
  switchProps
}: SwitchProps & {
  name: string;
  label: string;
  helperText?: string;
  labelProps?: FormControlLabelProps;
  switchProps?: SwitchProps;
}): JSX.Element {
  return (
    <>
      <FormControlLabel
        control={
          <Field name={name}>
            {({ meta, form }: FieldProps) => (
              <Switch
                color={
                  meta.error ? "secondary" : (switchProps?.color ?? "primary")
                }
                checked={!!meta.value}
                onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
                  form.setFieldValue(name, evt.target.checked)
                }
                {...switchProps}
              />
            )}
          </Field>
        }
        label={label}
        {...labelProps}
      />
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </>
  );
}
